import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=13ca8690&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/jobs/Applications/jobs/WebApps/jobs/dpr-field-calendar/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VIcon,VTooltip})
